export enum OptionStyle {
  Default = 0,
  Success = 1,
  Error = 2,
  Warning = 3,
  Legacy = 4,
}
